module.exports = __webpack_public_path__ + "img/143.f8495e03.png";